import { DOMAIN } from '../../../../../var_env.'
import { RequestResponsePattern } from '../../../../../types/Request'
import { postApi } from '../../../../../utils/requestApi'

type DeleteBody = {
  id: number
}

export default async function deleteAnaliseAmostraTerceira(id: number): Promise<void> {
  const endpoint = `${DOMAIN}/AnaliseAmostraTerceira/delete`
  const data: DeleteBody = { id }

  const response: RequestResponsePattern<any> = await postApi({ endpoint, data })

  if (response) {
    if (!response.flagErro) return
    throw new Error(response.listaMensagens[0])
  }

  throw new Error('Erro na requisição')
}

